<div class="group prose-text-sm relative">
  <div
    class="pointer-events-none absolute left-3 z-10 flex -translate-y-1/2 gap-2 px-2 transition-[top] duration-300 group-focus-within:prose-text-xs group-focus-within:top-0 group-focus-within:bg-white group-focus-within:text-neutral-500"
    [ngClass]="{
      'prose-text-xs top-0  text-neutral-500': !!value,
      'top-1/2 font-regular text-gray-400': !value,
      'bg-transparent': isDisabled,
      'bg-white': !isDisabled
    }">
    {{ label }}
    <span class="font-bold text-primary-500" *ngIf="required">*</span>
  </div>
  <ng-content></ng-content>
</div>
